const isLive = true;

export const SSO_API_URL = isLive
  ? 'https://sso-api.flocs.com'
  : 'http://localhost:3000';